import { CUSTOM_REPORT_GET_REPORT } from "./types";
import firebase from "firebase/app";

export const getStandaloneReport = (subjectName, uid, timestamp, reportType) => {
    return dispatch => {
        dispatch({
            type: CUSTOM_REPORT_GET_REPORT.REQUEST
        });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: CUSTOM_REPORT_GET_REPORT.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref(
                            `/subjects/${subjectName}/${uid}/reports/custom_report/${timestamp}`
                        )
                        .on("value", snapshot => {
                            dispatch({
                                type: CUSTOM_REPORT_GET_REPORT.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: CUSTOM_REPORT_GET_REPORT.FAIL
            });
        }
    };
};


export const getReport = (uid, subjectName, status, year, month, timestamp, reportType) => {
    return dispatch => {
        dispatch({
            type: CUSTOM_REPORT_GET_REPORT.REQUEST
        });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: CUSTOM_REPORT_GET_REPORT.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref(
                            `/subjects/${subjectName}/${status}/${year}/${month}/${uid}/reports/${reportType}/${timestamp}`
                        )
                        .on("value", snapshot => {
                            dispatch({
                                type: CUSTOM_REPORT_GET_REPORT.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: CUSTOM_REPORT_GET_REPORT.FAIL
            });
        }
    };
};
